import React, { Component } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Select, Button, Spin } from "antd";
import moment from "moment";
import fetchHandler from "@/fetch/fetchHandler";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { upgrade, getFirmwareList, stubCmdFirmware, getFrameWorkList, getUpdateTypeList } from "@/fetch/fetchApi";

const defaultDate = moment();
@monthPickerHoc
class frameWorkUpdateBatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridData: [],
      exportMes: "导出",
      option: [],
      frameTypeO:[],
      typeOption:[],
      primaryState: true,
      seconds: 11,
      btnLoading: false,
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubIdData,
      page: 1,
    };
    this.interval = null;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.getUpdateType();
    // this.getFrameWork();
  }

  // 点击获取最新版本
  getSeconds = () => {
    this.setState({
      btnLoading: true,
    });
    fetchHandler(stubCmdFirmware, {
      stubId: this.props.stubIds,
    }).then((res) => {
      this.setState({
        btnLoading: false,
      });
      if (res && (res.code === "success" || res.code === "ok")) {
        // 设置计时器
        this.interval = setInterval(() => {
          const seconds = this.state.seconds - 1;
          if (seconds < 0) {
            clearInterval(this.interval);
            this.getFrameWork();
          } else {
            this.setState({
              seconds: seconds,
            });
          }
        }, 1000);
      }
    });
  };

  
  // 获取固件版本
  getUpdateType() {
    this.setState({
      spinning: true,
      seconds: 11,
    });

    fetchHandler(getUpdateTypeList, {
    }).then((res) => {
      const typeOption = res.data;

      this.setState({
        typeOption: [...typeOption],
        spinning: false,
      });
    });
  }
// 获取固件型号
  getFrameType = (value) => {
    
    this.setState({
      spinning: true,
      seconds: 11,
    });

    fetchHandler(getFrameWorkList, {
      updateType:value
    }).then((res) => {
      const typeOption = res.data;

      this.setState({
        frameTypeO: [...typeOption],
        spinning: false,
      });
    });
  };

  getFrameWork = (value) => {
    
    this.setState({
      frameType:value,
      spinning: true,
      seconds: 11,
    });

    fetchHandler(getFirmwareList, {
      frameType: value,
    }).then((res) => {
      const option = res.data.map((item) => {
        let foo = {};
        if (item.smallVersion) {
          foo = {
            text: `${item.frameWork}-${item.smallVersion}(${item.desc})`,
            value: `${item.frameWork}-${item.smallVersion}`,
          };
        } else {
          foo = {
            text: `${item.frameWork}(${item.desc})`,
            value: item.frameWork,
          };
        }
        return foo;
      });
      console.info('结果')
      console.info(option)
      this.setState({
        option: [...option],
        spinning: false,
      });
    });
  };

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }


  // 固件升级
  frameWorkUpdateBatch() {
    //随机生成请求id，长度为9的数字
    var ls = this.props.stubIds.split(',');
    var stuR = [];
    var reqIds = [];
    ls.forEach((key) => {
      var reqId = moment(new Date()).format("SSS");
      for(var i=0;i<6;i++)
      {
        reqId = reqId + this.getRandomInt(0,9);
      }
      stuR.push({
        stubId: key,
        reqId: reqId
      })
      reqIds.push(reqId)
    });
    

    fetchHandler(upgrade, {
      stubId: JSON.stringify(stuR),
      frameType: this.state.frameType,
      frameWork: this.state.frameWork,
      smallVersion: this.state.smallVersion,
    }).then((res) => {
      if (res && res.code === "success") {
        this.props.frameWorkUpdateBatchFunc(JSON.stringify(stuR));
      } else {
        this.props.errorHandler();
      }
    });
  }

  // 点击刷新操作
  refreshCurrent = () => {
    // 清楚计时器
    clearInterval(this.interval);
    this.props.updateFramType();
    // 获取最新版本
    this.getFrameWork();
  };

  init() {}

  setFrameWork = (value) => {
    const frameInfo = value.split("-");
    this.setState({
      frameWork: frameInfo[0],
      primaryState: false,
      smallVersion: frameInfo.length === 2 ? frameInfo[1] : null,
    });
  };

  frameWorkUpdateBatchFunc() {
    if (this.state.frameWork) {
      this.frameWorkUpdateBatch();
    }
  }

  render() {
    return (
      <Form className="login-form update-frame-work-modal">
        <Spin spinning={this.state.spinning}>
        <Form.Item
            initialValue={this.props.updateType}
            label="固件型号:"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}>
            <Select placeholder="请选择" onChange={this.getFrameWork}>
              {this.state.typeOption.map((item) => {
                return <option value={item}> {item}</option>;
              })}
            </Select>
          </Form.Item>
          {/* <Form.Item
            initialValue={this.props.frameType}
            label="固件版本:"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}>
            <Select placeholder="请选择" onChange={this.getFrameWork}>
              {this.state.frameTypeO.map((item) => {
                return <option value={item}> {item}</option>;
              })}
            </Select>
          </Form.Item> */}
          <Form.Item
            initialValue={this.props.frameWork}
            label="固件版本:"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}>
            <Select placeholder="请选择" onChange={this.setFrameWork}>
              {this.state.option.map((item) => {
                return <option value={item.value}> {item.text}</option>;
              })}
            </Select>
          </Form.Item>
          {/* <div className="refresh-btn">
            <Button
              loading={this.state.btnLoading}
              disabled={this.state.seconds <= 10 && this.state.seconds >= 0}
              className="refresh-item"
              onClick={this.getSeconds}>
              获取设备最新版本
            </Button>
            {this.state.seconds <= 10 && this.state.seconds >= 0 && (
              <div className="tips">
                设备固件版本获取中，请过{this.state.seconds}秒后
                <a onClick={this.refreshCurrent}>刷新</a>查看！
              </div>
            )}
          </div> */}
          {/* <Form.Item
            label="固件信息："
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}
            style={{ display: this.state.btnDisplay }}>
            {this.props.smallVersion === "--" &&
            this.props.smallVersion !== "" &&
            this.props.smallVersion
              ? `${this.props.frameType}-${this.props.frameWork}`
              : `${this.props.frameType}-${this.props.frameWork}-${this.props.smallVersion}`}
          </Form.Item> */}

          <Form.Item wrapperCol={{ span: 15, offset: 5 }} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              disabled={this.state.primaryState}
              onClick={() => {
                this.frameWorkUpdateBatchFunc();
              }}>
              确定
            </Button>
            <Button type="default" onClick={this.props.onCancel} style={{ marginLeft: "20px" }}>
              取消
            </Button>
          </Form.Item>
        </Spin>
      </Form>
    );
  }
}

export default frameWorkUpdateBatch;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/frameWorkUpdateBatch.js